import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleDown } from "@fortawesome/pro-solid-svg-icons/faAngleDoubleDown";
import { faAngleDoubleUp } from "@fortawesome/pro-solid-svg-icons/faAngleDoubleUp";
import { WithTranslation, withTranslation } from 'react-i18next';

interface IProps {
    expanded: boolean;
    moreText?: string | React.ReactNode;
    lessText?: string | React.ReactNode;
    className?: string;
    onClick?: (expanded: boolean) => void;
}

type Props = IProps & WithTranslation;

class ButtonExpander extends React.PureComponent<Props> {

    constructor(props: Props) {
        super(props);
        this.state = {
            dialog: null
        };
    }

    render() {
        const moreText = this.props.moreText || this.props.t("Common.Literals.MoreText");
        const lessText = this.props.lessText || this.props.t("Glossary.LessText");

        const buttonText = this.props.expanded
            ? <span><FontAwesomeIcon fixedWidth icon={faAngleDoubleUp} />{lessText}</span>
            : <span><FontAwesomeIcon fixedWidth icon={faAngleDoubleDown} />{moreText}</span>;

        return (
            <button
                className={this.props.className}
                onClick={
                    () => {
                        if (this.props.onClick) this.props.onClick(!this.props.expanded);
                    }
                }
            >
                {buttonText}
            </button>
        );
    }
}

export default withTranslation()(ButtonExpander);